type stateT = Array<organizationT>;

// ACTIONS
export type actionT = {
  type: 'UPDATE_ORGANIZATIONS_INFO',
  organizations: Array<organizationT>,
};

export function updateOrganizationsInfo({ organizations }: { organizations: Array<organizationT> }): actionT {
  return {
    type: 'UPDATE_ORGANIZATIONS_INFO',
    organizations,
  };
}

// STORE
const initialOrganizationsState: stateT = [];

export function organizationsInfo(state: stateT = initialOrganizationsState, action: actionT): stateT {
  switch (action.type) {
    case 'UPDATE_ORGANIZATIONS_INFO':
      return action.organizations || [];
    default:
      return state;
  }
}

// function to decide if we should show the end of trial modal
export function displayEndOfTrialModal(state: stateT, orgId: string): boolean {
  return (
    state.length &&
    state.some(
      (org) =>
        org.id === orgId &&
        (org.status === 'churned' ||
          org.status === 'not_paying' ||
          org.status === 'paying_business_trial_ended' ||
          org.status === 'revoked'),
    )
  );
}
